// @ts-strict-ignore
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromUserGroups from '../reducers/employee-group.reducer';
import { EmployeeGroup } from '@fc-core';

import { SortBy } from '@fc-shared/ui/sort-by/sort-by';
import { sortByPropertyWithOrder } from '@fc-shared/utils/sort-by-property';
import { selectRouteParams } from '@fc-store/selectors/router.selectors';
export const getUserGroupsState = createFeatureSelector<fromUserGroups.State>(
  fromUserGroups.employeeGroupFeatureKey,
);
export const getAllUserGroups = createSelector(
  getUserGroupsState,
  fromUserGroups.selectAll,
);

export const getUserGroupsEntities = createSelector(
  getUserGroupsState,
  fromUserGroups.selectEntities,
);

export const getUserGroupSearchText = createSelector(
  getUserGroupsState,
  fromUserGroups.getUserGroupSearchText,
);

export const getEmployeeGroupSortBy = createSelector(
  getUserGroupsState,
  fromUserGroups.getSortBy,
);
export const getEmployeeGroupSortByList = createSelector(
  getUserGroupsState,
  fromUserGroups.getSortByList,
);

export const getUserGroupError = createSelector(
  getUserGroupsState,
  fromUserGroups.getUserGroupError,
);

export const getEmployeeGroupLoading = createSelector(
  getUserGroupsState,
  fromUserGroups.getUserGroupLoading,
);

export const getCurrentUserGroup = createSelector(
  selectRouteParams,
  getUserGroupsEntities,
  ({ id }, groupEntities) => groupEntities[id],
);

export const getEmployeeGroups = createSelector(
  getAllUserGroups,
  getUserGroupSearchText,
  getEmployeeGroupSortBy,
  (
    userGroups: EmployeeGroup[],
    searchText: string,
    groupSort: SortBy,
  ): EmployeeGroup[] => {
    userGroups = groupSorting(userGroups, groupSort);
    if (searchText?.length) {
      userGroups = userGroups.filter((userGroup) =>
        userGroup.name.toLowerCase().includes(searchText?.toLowerCase()),
      );
    }
    return userGroups;
  },
);

export const getUserGroupById = (userGroupId: number) =>
  createSelector(getAllUserGroups, (userGroups: EmployeeGroup[]) => {
    const foundedUserGroup = userGroups.filter(
      (group) => group.id === userGroupId,
    );
    return foundedUserGroup.length ? foundedUserGroup[0] : null;
  });

export const groupSorting = (userGroups: EmployeeGroup[], sortBy: SortBy) => {
  if (!userGroups.length && !sortBy) return [];
  if (sortBy.value === 'name') {
    return sortByPropertyWithOrder<EmployeeGroup>(
      userGroups,
      'name',
      sortBy.order,
    );
  }
  if (sortBy.value === 'numbers') {
    return userGroups.sort((a, b) =>
      sortBy.order
        ? b.employees.length - a.employees.length
        : a.employees.length - b.employees.length,
    );
  }
  return userGroups;
};
